import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_Get_Community = {
  id: Id;
};

export type ApiResponse_Get_Community = {
  id: number;
  name: string;
  description: string;
  rules?: string;
  require_verification: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  metadata?: Record<string, unknown>;
  member_count: number;
  pending_count: number;
  user_role: 'ADMIN' | 'MEMBER' | null;
  user_status: 'PENDING' | 'ACTIVE' | 'INACTIVE' | 'BANNED' | null;
  members: Array<{
    id: string;
    membership_id: number;
    email: string;
    full_name: string;
    role: 'ADMIN' | 'MEMBER';
    joined_at: string;
    is_verified: boolean;
    status: 'PENDING' | 'ACTIVE' | 'INACTIVE' | 'BANNED';
  }>;
};

const METHOD = 'GET';
const ENDPOINT = 'communities';
export const QUERY_KEY = (params: ApiRequest_Get_Community) =>
  getQueryKey(METHOD, `${ENDPOINT}/${params.id}`, {});

export const useGetCommunity = (params: ApiRequest_Get_Community, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token && !!params.id,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      const data = await handleApiCall<ApiResponse_Get_Community, Record<string, never>>(
        session,
        METHOD,
        getResolvedEndpoint(`${ENDPOINT}/${params.id}`, {}),
        {}
      );

      return data;
    },
  });
};
